import autoTable from "jspdf-autotable";

import {
  PDF_TABLE_STYLE,
  PDFCOLORSHEME,
} from "../../../../../../component/constent";

export function drawShopTable(doc, shop, rows, total) {
  let startY = 15;

  const format = (value) => {
    return Number(value || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const columnStyles = {
    0: { cellWidth: 10, halign: "left" },
    1: { cellWidth: 40, halign: "left" },
    2: { cellWidth: 30, halign: "right" },
    3: { cellWidth: 30, halign: "right" },
    4: { cellWidth: 30, halign: "right" },

    5: { cellWidth: 40, halign: "left" },
    6: { cellWidth: 30, halign: "right" },
    7: { cellWidth: 30, halign: "right" },
    8: { cellWidth: 30, halign: "right" },
  };

  const pageHeight = doc.internal.pageSize.getHeight();

  if (startY > pageHeight - 25) {
    doc.addPage();
    startY = 5;
  }

  autoTable(doc, {
    startY,

    ...PDF_TABLE_STYLE,

    head: [
      [
        {
          content: "Debit",
          colSpan: 5,
          styles: {
            halign: "center",
            fontStyle: "bold",
          },
        },
        {
          content: "Credit",
          colSpan: 4,
          styles: {
            halign: "center",
            fontStyle: "bold",
          },
        },
      ],

      [
        "Sr No.",
        "PARTICULARS",
        "OB",
        "During the Month",
        "End of the month",

        "PARTICULARS",
        "OB",
        "During the Month",
        "End of the month",
      ],
    ],

    body: rows.map((r) => [
      r.srno,

      (r.drparticulars || "").trim(),
      format(r.drOB),
      format(r.drCurrent),
      format(r.drCB),

      (r.CrParticulars || "").trim(),
      format(r.crOB),
      format(r.crCurrent),
      format(r.CrCB),
    ]),

    styles: {
      fontSize: 7,
      halign: "right",
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_HEADER,
      textColor: PDFCOLORSHEME.FONT_COLOR_HEADER,
      halign: "center",
      fontStyle: "bold",
    },

    columnStyles,

    didParseCell: function (data) {
      /*
       * ==========================================
       * FIRST HEADER
       * ==========================================
       */

      if (data.section === "head" && data.row.index === 0) {
        // Debit heading
        if (data.column.index === 0) {
          data.cell.styles.fillColor = [52, 73, 94];
          data.cell.styles.textColor = [255, 255, 255];
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.halign = "center";
        }

        // Credit heading
        if (data.column.index === 5) {
          data.cell.styles.fillColor = [39, 100, 70];
          data.cell.styles.textColor = [255, 255, 255];
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.halign = "center";
        }
      }

      /*
       * ==========================================
       * BODY - TOTAL / NET HIGHLIGHT
       * ==========================================
       */

      if (data.section === "body") {
        const row = rows[data.row.index];

        const drParticular = String(
          row?.drparticulars || ""
        )
          .trim()
          .toUpperCase();

        const crParticular = String(
          row?.CrParticulars || ""
        )
          .trim()
          .toUpperCase();

        /*
         * Check Debit side
         */
        const isDebitTotal =
          drParticular.includes("TOTAL") ||
          drParticular.includes("NET");

        /*
         * Check Credit side
         */
        const isCreditTotal =
          crParticular.includes("TOTAL") ||
          crParticular.includes("NET");

        /*
         * ==========================================
         * DEBIT SIDE
         * Columns 0 - 4
         * ==========================================
         */

        if (
          isDebitTotal &&
          data.column.index >= 0 &&
          data.column.index <= 4
        ) {
          data.cell.styles.fillColor = [255, 243, 205];
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.textColor = [0, 0, 0];
        }

        /*
         * ==========================================
         * CREDIT SIDE
         * Columns 5 - 8
         * ==========================================
         */

        if (
          isCreditTotal &&
          data.column.index >= 5 &&
          data.column.index <= 8
        ) {
          data.cell.styles.fillColor = [220, 245, 230];
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.textColor = [0, 0, 0];
        }
      }
    },
  });

  /*
   * ==========================================
   * SIGNATURES
   * ==========================================
   */

  const finalY = doc.lastAutoTable.finalY;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);

  doc.text(
    "Dy CME/Repair",
    35,
    finalY + 15,
    {
      align: "center",
    }
  );

  doc.text(
    "Sr AFA/MWS",
    245,
    finalY + 15,
    {
      align: "center",
    }
  );

  doc.lastAutoTable.finalY = finalY + 25;
}